import {
  Box,
  Button,
  Modal,
  Slide,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { pxToRem, pxTovW } from '../../../../commonUtils/resizeUtils';
import { IStyles } from '../../../../commonUtils/styleUtils';
import ImageWrapper from '../../../elements/ImageWrapper';
import { IconWrapper } from '../../../elements/IconWrapper/Index';

const styles: IStyles = {
  root: {},
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  imageUrl?: string;
  imageName?: string;
}
export const ImagePopup = (props: IProps) => {
  const theme = useTheme();
  const { open, handleClose, imageUrl, imageName } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Modal open={open} onClose={handleClose}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
          }}
          onClick={handleClose}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // mt: { xs: '18%', md: '10%' },
              gap: { xs: pxToRem(80), md: pxTovW(20) },
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'center', md: 'flex-start' },
              maxWidth: '95%',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
              }}
            >
              <ImageWrapper
                name={imageName || ''}
                path={imageUrl}
                type={'png'}
                styles={{
                  maxWidth: {
                    xs: 'calc(100vw - 25px)',
                    md: 'calc(100vw - 100px)',
                  },
                  maxHeight: {
                    xs: 'calc(100vh - 100px)',
                    md: 'calc(100vh - 100px)',
                  },
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </Box>

            <Button onClick={handleClose} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
